export const palettes = {
  yield: {
    RdYlGn: {
      6: ['#d73027', '#fc8d59', '#fee08b', '#d9ef8b', '#91cf60', '#1a9850'],
      7: [
        '#d73027',
        '#fc8d59',
        '#fee08b',
        '#ffffbf',
        '#d9ef8b',
        '#91cf60',
        '#1a9850',
      ],
      8: [
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#d9ef8b',
        '#a6d96a',
        '#66bd63',
        '#1a9850',
      ],
      9: [
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#ffffbf',
        '#d9ef8b',
        '#a6d96a',
        '#66bd63',
        '#1a9850',
      ],
      10: [
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#d9ef8b',
        '#a6d96a',
        '#66bd63',
        '#1a9850',
        '#006837',
      ],
    },
    Classic: {
      6: ['#ff0000', '#ff5a00', '#ffaa00', '#ffd900', '#b7d800', '#00bc00'],
      7: [
        '#ff0000',
        '#ff5a00',
        '#ffaa00',
        '#fff300',
        '#ffd900',
        '#b7d800',
        '#00bc00',
      ],
      8: [
        '#ff0000',
        '#f52b00',
        '#ff9300',
        '#ffaa00',
        '#ffd900',
        '#a9ca00',
        '#00a201',
        '#00bc00',
      ],
      9: [
        '#ff0000',
        '#f52b00',
        '#ff9300',
        '#ffaa00',
        '#fff300',
        '#ffd900',
        '#a9ca00',
        '#00a201',
        '#00bc00',
      ],
      10: [
        '#5b0003',
        '#ff0000',
        '#f52b00',
        '#ff9300',
        '#ffaa00',
        '#ffd900',
        '#a9ca00',
        '#00a201',
        '#00bc00',
        '#004515',
      ],
    },
  },

  moisture: {
    moistBl: {
      6: ['#eff3ff', '#c6dbef', '#9ecae1', '#6baed6', '#2171b5', '#08519c'],
      7: [
        '#eff3ff',
        '#c6dbef',
        '#9ecae1',
        '#6baed6',
        '#4292c6',
        '#2171b5',
        '#084594',
      ],
      8: [
        '#f7fbff',
        '#deebf7',
        '#c6dbef',
        '#9ecae1',
        '#6baed6',
        '#4292c6',
        '#2171b5',
        '#084594',
      ],
      9: [
        '#f7fbff',
        '#deebf7',
        '#c6dbef',
        '#9ecae1',
        '#6baed6',
        '#4292c6',
        '#2171b5',
        '#08519c',
        '#08306b',
      ],
    },
  },

  speed: {
    speedYlRd: {
      6: ['#ffffb2', '#fed976', '#feb24c', '#fd8d3c', '#f03b20', '#bd0026'],
      7: [
        '#ffffb2',
        '#fed976',
        '#feb24c',
        '#fd8d3c',
        '#fc4e2a',
        '#e31a1c',
        '#b10026',
      ],
      8: [
        '#ffffcc',
        '#ffeda0',
        '#fed976',
        '#feb24c',
        '#fd8d3c',
        '#fc4e2a',
        '#e31a1c',
        '#b10026',
      ],
      9: [
        '#ffffcc',
        '#ffeda0',
        '#fed976',
        '#feb24c',
        '#fd8d3c',
        '#fc4e2a',
        '#e31a1c',
        '#bd0026',
        '#800026',
      ],
    },
  },

  header_height: {
    headerHeightYlGr: {
      6: ['#ffffcc', '#d9f0a3', '#addd8e', '#78c679', '#31a354', '#006837'],
      7: [
        '#ffffcc',
        '#d9f0a3',
        '#addd8e',
        '#78c679',
        '#41ab5d',
        '#238443',
        '#005a32',
      ],
      8: [
        '#ffffe5',
        '#f7fcb9',
        '#d9f0a3',
        '#addd8e',
        '#78c679',
        '#41ab5d',
        '#238443',
        '#005a32',
      ],
      9: [
        '#ffffe5',
        '#f7fcb9',
        '#d9f0a3',
        '#addd8e',
        '#78c679',
        '#41ab5d',
        '#238443',
        '#006837',
        '#004529',
      ],
    },
  },

  dem: {
    Terrain: {
      6: ['#006837', '#78c679', '#ffffcc', '#d8b365', '#8c510a', '#f5f5f5'],
    },
    Viridis: {
      6: ['#440154', '#414487', '#2a788e', '#22a884', '#7ad151', '#fde725'],
    },
    GreyScale: {
      6: ['#f7f7f7', '#d9d9d9', '#bdbdbd', '#969696', '#636363', '#252525'],
    },
  },

  general: {
    RdYlBu: {
      6: ['#d73027', '#fc8d59', '#fee090', '#e0f3f8', '#91bfdb', '#4575b4'],
      7: [
        '#d73027',
        '#fc8d59',
        '#fee090',
        '#ffffbf',
        '#e0f3f8',
        '#91bfdb',
        '#4575b4',
      ],

      8: [
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee090',
        '#e0f3f8',
        '#abd9e9',
        '#74add1',
        '#4575b4',
      ],

      9: [
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee090',
        '#ffffbf',
        '#e0f3f8',
        '#abd9e9',
        '#74add1',
        '#4575b4',
      ],

      10: [
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee090',
        '#e0f3f8',
        '#abd9e9',
        '#74add1',
        '#4575b4',
        '#313695',
      ],
    },
    BrYlGn: {
      6: ['#8c510a', '#d8b365', '#f6e8c3', '#c7eae5', '#5ab4ac', '#01665e'],
      7: [
        '#8c510a',
        '#d8b365',
        '#f6e8c3',
        '#f5f5f5',
        '#c7eae5',
        '#5ab4ac',
        '#01665e',
      ],

      8: [
        '#8c510a',
        '#bf812d',
        '#dfc27d',
        '#f6e8c3',
        '#c7eae5',
        '#80cdc1',
        '#35978f',
        '#01665e',
      ],

      9: [
        '#8c510a',
        '#bf812d',
        '#dfc27d',
        '#f6e8c3',
        '#f5f5f5',
        '#c7eae5',
        '#80cdc1',
        '#35978f',
        '#01665e',
      ],

      10: [
        '#543005',
        '#8c510a',
        '#bf812d',
        '#dfc27d',
        '#f6e8c3',
        '#c7eae5',
        '#80cdc1',
        '#35978f',
        '#01665e',
        '#003c30',
      ],
    },
    PuPiGn: {
      6: ['#762a83', '#af8dc3', '#e7d4e8', '#d9f0d3', '#7fbf7b', '#1b7837'],
      7: [
        '#762a83',
        '#af8dc3',
        '#e7d4e8',
        '#f7f7f7',
        '#d9f0d3',
        '#7fbf7b',
        '#1b7837',
      ],

      8: [
        '#762a83',
        '#9970ab',
        '#c2a5cf',
        '#e7d4e8',
        '#d9f0d3',
        '#a6dba0',
        '#5aae61',
        '#1b7837',
      ],

      9: [
        '#762a83',
        '#9970ab',
        '#c2a5cf',
        '#e7d4e8',
        '#f7f7f7',
        '#d9f0d3',
        '#a6dba0',
        '#5aae61',
        '#1b7837',
      ],
      10: [
        '#40004b',
        '#762a83',
        '#9970ab',
        '#c2a5cf',
        '#e7d4e8',
        '#d9f0d3',
        '#a6dba0',
        '#5aae61',
        '#1b7837',
        '#00441b',
      ],
    },
    RdPeBu: {
      6: ['#b2182b', '#ef8a62', '#fddbc7', '#d1e5f0', '#67a9cf', '#2166ac'],
      7: [
        '#b2182b',
        '#ef8a62',
        '#fddbc7',
        '#f7f7f7',
        '#d1e5f0',
        '#67a9cf',
        '#2166ac',
      ],

      8: [
        '#b2182b',
        '#d6604d',
        '#f4a582',
        '#fddbc7',
        '#d1e5f0',
        '#92c5de',
        '#4393c3',
        '#2166ac',
      ],

      9: [
        '#b2182b',
        '#d6604d',
        '#f4a582',
        '#fddbc7',
        '#f7f7f7',
        '#d1e5f0',
        '#92c5de',
        '#4393c3',
        '#2166ac',
      ],

      10: [
        '#67001f',
        '#b2182b',
        '#d6604d',
        '#f4a582',
        '#fddbc7',
        '#d1e5f0',
        '#92c5de',
        '#4393c3',
        '#2166ac',
        '#053061',
      ],
    },
  },
}
